import { render, staticRenderFns } from "./SvgRenderer.vue?vue&type=template&id=70355800&scoped=true&"
import script from "./SvgRenderer.vue?vue&type=script&lang=js&"
export * from "./SvgRenderer.vue?vue&type=script&lang=js&"
import style0 from "./SvgRenderer.vue?vue&type=style&index=0&id=70355800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70355800",
  null
  
)

export default component.exports